import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { InternalDocument } from '../model/internal-document';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  private documentUrl = environment.baseUrl + '/document';

  constructor(
    private http: HttpClient
  ) {
  }

  downloadDocument(document: InternalDocument): void {
    if (document.file) {
      this.downLoadFile(document.file, document.fileType);
    } else if (document.fileUrl && document.fileUrl.indexOf('/comparator/') > 0) {
      window.open(document.fileUrl, '_blank');
    } else {
      this.http.put(this.documentUrl, document, {
          responseType: 'arraybuffer'
        }
      ).subscribe(response => this.downLoadFile(response, document.fileType));
    }
  }

  downLoadFile(data: any, type: string): void {
    const blob = new Blob([data], { type });
    const url = window.URL.createObjectURL(blob);
    const pwa = window.open(url);
    if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
      alert('Please disable your Pop-up blocker and try again.');
    }
  }
}
